import { render } from "./CorporationsFilter.vue?vue&type=template&id=6cf4f71b&ts=true"
import script from "./CorporationsFilter.vue?vue&type=script&lang=ts"
export * from "./CorporationsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__